
    // this file was auto generated by python script
    import Maximize2 from './Maximize2';
    export default Maximize2;
    